/**
 * Available color options for the save button
 * Users can select their preferred color from this palette
 */
export const SAVE_BUTTON_COLORS = [
    { hex: '#FF009D', name: 'Pink' },
    { hex: '#10732F', name: 'Green' },
    { hex: '#8400FF', name: 'Purple' },
    { hex: '#FF0000', name: 'Red' },
    { hex: '#FFBB00', name: 'Yellow' },
    { hex: '#18C3C6', name: 'Aqua' },
    { hex: '#002FFF', name: 'Blue' },
    { hex: '#FF6600', name: 'Orange' },
    { hex: '#743A0A', name: 'Brown' },
] as const

export type SaveButtonColor = (typeof SAVE_BUTTON_COLORS)[number]
